import React, { memo } from 'react';

import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { emptyMessageStyles } from './CicEmptyMessage.styles';

const CicEmptyMessage = ({ message, dataTestId = null }) => (
  <Typography
    color="text.secondary"
    data-testid={dataTestId}
    sx={emptyMessageStyles}
    variant="regular14"
  >
    {message}
  </Typography>
);

CicEmptyMessage.propTypes = {
  message: PropTypes.string.isRequired,
  dataTestId: PropTypes.string,
};

export default memo(CicEmptyMessage);
